import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import axios from "axios";
import { API_BASE_URL } from "@/config/serverApiConfig";
import { Breadcrumb, Spinner } from "react-bootstrap";
import SubmitPopup from "@/components/UserView/Submitpopup/Submitpopup";




export default function Changepassword() {

    const history = useHistory();
    const user = JSON.parse(localStorage.getItem("auth"));
  
    let userId 
    user ? userId = user.current.id : userId = null;
    
    const token = localStorage.getItem("x-auth-token");
    if(!token || !userId|| !user) {
        history.push("/admin/login");
    }
    

    // create a axois post api that send formData to backend
   
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [currentPasswordIsEmpty, setCurrentPasswordIsEmpty] = useState(false);
    const [passwordMatchErr, setPasswordMatchErr] = useState(false);
    const [passwordIsEmpty, setPasswordIsEmpty] = useState(false);
    const [confirmPasswordIsEmpty, setConfirmPasswordIsEmpty] = useState(false);
    
    let [updatedMSG, setUpdatedMSG] = useState(false);

    const [submitLoader, setSubmitLoader] = useState(false);

    const [msg, setMsg] = useState("");

    function closeupdateModal() {
        setUpdatedMSG(false);
        // refresh the page
        history.push("/admin/admin-panel/change-password");
        
      }

    function currentpasswordHandler(e) {
        let item = e.target.value;
        if(item.length < 8) {
            setCurrentPasswordIsEmpty(true);
        } else {
            setCurrentPasswordIsEmpty(false);
        }
        setCurrentPassword(item);

    }
    
    function passwordHandler(e) {
        let item = e.target.value;
        if(item.length < 8) {
            setPasswordIsEmpty(true);
        } else {
            setPasswordIsEmpty(false);
        }
        setPassword(item);

    }

    function confirmPasswordHandler(e) {
        let item = e.target.value;
        if(item.length < 8) {
            setConfirmPasswordIsEmpty(true);
        }
        else if (item !== password) {
            setPasswordMatchErr(true);
        }

        else {
            setConfirmPasswordIsEmpty(false);
        }
        setConfirmPassword(item);
    }

    let formData = new FormData();
    function submitHandler(e) {
        e.preventDefault();
        if(currentPassword === "" || currentPassword === undefined) {
            setCurrentPasswordIsEmpty(true);
        }
        else if(password === "") {
            setPasswordIsEmpty(true);
        }
        else if(confirmPassword === "") {
            setConfirmPasswordIsEmpty(true);
        }
        else if(password !== confirmPassword) {
            setPasswordMatchErr(true);
        }
        else if(password === confirmPassword && password.length >= 8) {
            setPasswordMatchErr(false);
            setPasswordIsEmpty(false);
            setConfirmPasswordIsEmpty(false);
            setCurrentPasswordIsEmpty(false);

    
    formData.append("id", userId);
    formData.append("oldPassword", currentPassword);
    formData.append("newPassword", confirmPassword);

    
    setSubmitLoader(true);
    axios.post(`${API_BASE_URL}admin/changepassword`,
    {id:userId,
        oldPassword:currentPassword,
        newPassword:password,
        }

     )
    .then(function (response) {
        setMsg(response.data.message);
        setUpdatedMSG(true);

      setSubmitLoader(false);
      
    })
    .catch(err => {
      setSubmitLoader(false);

    })
}}
 

    return (
        <>
         <SubmitPopup
        onClose={closeupdateModal}
        show={updatedMSG}
        title={msg}
      />
        
        
        <div className="container">
            <div className="row">
                 <div className="col-md-6 offset-md-3">
                     <div className="logo" style={{"text-align": "center",
    "margin-top": "40px"}}>

                  <img src="./assets/images/logo_black.png" alt="logo" className="logocenter" />
                  </div>
                    <h1 className="text-center" style={{margin: "60px"}}>Change Password</h1>
                   
                    <form  onSubmit={submitHandler}>
                        <div style={{"marginBottom": "20px"}} className="form-groupp">
                            <label htmlFor="oldPassword">Enter Current Password</label>
                            <input
                                type="password"
                                name="oldPassword"
                                className="form-control"
                                id="oldPassword"
                                placeholder="********"
                                onChange={currentpasswordHandler}
                                
                            />
                            {currentPasswordIsEmpty ? (
                                <span className="error-msg">Please enter your current password</span>
                              ) : (
                                ""
                              )}
                        </div>
                        <div style={{"marginBottom": "20px"}} className="form-group">
                            <label htmlFor="newPassword">Enter New Password</label>
                            <input
                                type="password"
                                name="newPassword"
                                className="form-control"
                                id="newPassword"
                                placeholder="********"
                                onChange={passwordHandler}
                                
                            />
                            {passwordIsEmpty ? (
                              <span className="error-msg">Please enter your new password</span>
                            ) : (
                              ""
                            )}
                        </div>
                        <div style={{"marginBottom": "20px"}} className="form-group">
                            <label htmlFor="confirmPassword">Confirm New Password</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                className="form-control"
                                id="confirmPassword"
                                placeholder=" ********"
                                onChange={confirmPasswordHandler}
                               
                            />
                            {confirmPasswordIsEmpty ? (
                               <span className="error-msg">Password is not match</span>
                             ) : (
                               ""
                             )}
                        </div>
                    <button style={{"border-radius": "6px",
    padding: "15px 20px",
    width: "200px"}} type="submit" onSubmit={submitHandler} className="btn-full-color"> <Spinner
                      as="span"
                      animation={submitLoader ? 'border' : ''}
                      size="large"
                      role="status"
                      aria-hidden="false"
                    />Change Password</button>
                  
                  </form>
                    {/* {isLoading && <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>}
                    {isError && <div className="alert alert-danger" role="alert">
                        {t("changePassword.error")}
                    </div>}
                    {isSuccess && <div className="alert alert-success" role="alert">
                        {t("changePassword.success")}
                    </div>} */}
                </div> 
            </div> 
        </div>
        </>
    );
}
